module.exports = __webpack_public_path__ + "img/gold_framed_symbols.5fb0a71a.png";